<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="400"
  >
    <v-card>
      <v-card-title class="text-h5">
        Delete {{ document.title }}
      </v-card-title>
      <v-card-text>Permanently delete this document <b>({{ documentTitle }})</b>? <br> You can't undo this.</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="green darken-1"
          text
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="onDocumentDelete"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PEPartyDeleteDocumentDialog',

  props: {
    document: {
      type: Object,
      required: true,
    },

    onDocumentDelete: {
      type: Function,
      required: true,
    },

    value: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    dialog: {
      get () { return this.value },

      set (val) {
        this.$emit('input', val)
      },
    },

    documentTitle () {
      return this.document?.document?.blob.filename || ''
    },
  },
}
</script>
